export const NO_INFO = '---';
export const TABLE_SIZE = 'small';
export const TABLE_HEIGHT = 'calc(100vh - 200px)';
